import { useInfiniteQuery } from "react-query";
import { API_MSP_LIST_V2, QUERIES } from "consts";
import { useHttpClient } from "contexts/httpClient";
import { updateMspStatus } from "utils/formatter";
import { getMspList, interceptMspDetails } from "apis/msp.apis";
import { useAutoFetchInfiniteQuery } from "hooks/useAutoFetchInfiniteQuery";
import { IGetMSPList, IMsp } from "types/apis/msp.types";

export function useAllMSPListPages() {
  const httpClient = useHttpClient();
  return useInfiniteQuery(
    [QUERIES.getMspList],
    ({ pageParam = "" }) => getMspList({ httpClient, pageParam }),
    {
      // @ts-expect-error - data is not defined in the type
      select: (data) =>
        (data?.pages?.flatMap((page) => page.data) || []).map(updateMspStatus),
      getNextPageParam: ({ pageParam }) => {
        return pageParam || undefined;
      },
      meta: {
        disableFullPageLoader: true,
      },
      staleTime: 1000 * 60 * 5,
    }
  );
}

export const useMspList = () => {
  const {
    data: mspList,
    hasNextPage,
    isFetching,
  } = useAutoFetchInfiniteQuery<IMsp>({
    dataKey: "mspList",
    apiUrl: API_MSP_LIST_V2,
    queryKeys: [QUERIES.getMspList],
    dataInterceptor: interceptMspDetails,
    queryParams: { includeDetails: true },
  });

  const canFetchMore = hasNextPage === undefined || hasNextPage;

  return {
    mspList,
    isFetching,
    canFetchMore,
  };
};
